import { appFormUtil } from 'modules/common';
import React, { useEffect } from 'react';
import {
  GetProjectInstallationsDocument,
  useRemoveInstallationMutation
} from 'generated/graphql';

export type IFormState = {
  id: string;
};

const initialState = {
  id: ''
};

export function useFormState(id: string) {
  const { formState, dispatch, genFieldProps } = appFormUtil.useFormState({
    initialState,
    key2FieldConfig: {
      id: {
        label: 'Id',
        type: 'text'
      }
    }
  });

  useEffect(() => {
    if (formState.id === '' && id !== '') {
      dispatch({
        type: 'UPDATE',
        payload: {
          property: 'id',
          value: id
        }
      });
    }
    return () => {};

  }, [
    dispatch,
    formState.id,
    id
  ]);

  return React.useMemo(
    () => {

      return {
        formState,
        dispatch,
        genFieldProps
      };
    },
    [
      dispatch,
      formState,
      genFieldProps
    ]
  );
}

export function useRemoveInstallation() {
  const [
    fnMutate,
    tuple
  ] = useRemoveInstallationMutation({
    refetchQueries: []
  });
  const fnWrappedMutate = React.useCallback(
    async (id: string, projectId: string) => {
      await fnMutate({
        variables: {
          id
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: GetProjectInstallationsDocument,
            variables: {
              projectId: projectId
            }
          }
        ]
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
